import { render } from "./selectedCustomerModal.vue?vue&type=template&id=094d4471&scoped=true"
import script from "./selectedCustomerModal.vue?vue&type=script&lang=js"
export * from "./selectedCustomerModal.vue?vue&type=script&lang=js"

import "./selectedCustomerModal.vue?vue&type=style&index=0&id=094d4471&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094d4471"]])

export default __exports__